import './LeftHome.scss'
import MarketReview1 from './LeftHomeComponents/MarketReview1'
import MarketReview2 from './LeftHomeComponents/MarketReview2'
import PropertyTrends from './LeftHomeComponents/PropertyTrends'

export default function LeftHome() {
  return (
    <>
      <div className='evgyjaokxi'>
        <div className='rkttwetdkz'>Thị trường thế giới</div>
        <div className='rimiyfmbok'>
          <div className='gojggrbwwo'>
            <PropertyTrends />
          </div>
          <div className='ljxdrjucve'>
            <MarketReview1 />
            {/* <MarketReview2 /> */}
          </div>
        </div>
      </div>
    </>
  )
}